const INSTIL_AUTH_HEADER = 'X-Dotorg-Authorization';
const INSTIL_CLIENT_SCOPE_HEADER = 'X-Dotorg-Client-Scope';
const INSTIL_API_VERSION_HEADER = 'X-Dotorg-Api-Version';

export {
  INSTIL_AUTH_HEADER,
  INSTIL_CLIENT_SCOPE_HEADER,
  INSTIL_API_VERSION_HEADER,
};
